import { getScoreLetterFromKgeCO2PerParticipant } from '@/domain/impact-calculate/utils/get-score-letter-from-co2-per-participant';

export function computeCo2ScoreLetter(kgeCO2ByParticipant: number): string {
  const letter = getScoreLetterFromKgeCO2PerParticipant(
    kgeCO2ByParticipant,
    'venue',
  );
  return letter;
}
